import { render, staticRenderFns } from "./IconDiamond.vue?vue&type=template&id=4115f795&scoped=true"
var script = {}
import style0 from "./IconDiamond.vue?vue&type=style&index=0&id=4115f795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4115f795",
  null
  
)

export default component.exports